var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"22px","display":"inline-block"}},[(_vm.msg && _vm.msg.length > 0)?_c('span',{staticClass:"read-message"},[_c('i',{staticClass:"el-icon-success"}),_vm._v(" "+_vm._s(_vm.msg)+" "),_c('i',{staticClass:"el-icon-circle-close",staticStyle:{"cursor":"pointer"},on:{"click":_vm.close}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }